<template>
    <v-app>

        <LoadingComponent :isLoading="$store.getters.loadingModal"/>
        <LoginModal/>
        <ErrorPopup/>
        <v-app-bar
                app
                clipped-left
                style="max-height:55px;justify-content:center;background: rgb(0,83,108);background: linear-gradient(0deg, rgba(0,83,108,0.999019676229867) 15%, rgba(0,186,196,1) 100%);"
                dark
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>


            <v-row style="text-align: left;">
                <v-col cols="5">
                    <v-img :src="require('./assets/EUDOXUS_NEW_LOGO.png')" style=" max-height:170px; max-width:200px"
                           contain alt=""></v-img>
                    <!--                    <img  style=" max-height:170px; max-width:200px" src="../src/assets/EUDOXUS_NEW_LOGO.png"/>-->
                </v-col>
            </v-row>

            <v-row>
                <v-col class="text-center title">
                    <p>{{$route.meta.title}}</p>
                </v-col>
            </v-row>

            <v-spacer></v-spacer>

            <v-btn small outlined color="secondary" @click="logout" class="black--text">
                <v-icon>exit_to_app</v-icon>
                ΑΠΟΣΥΝΔΕΣΗ
            </v-btn>

        </v-app-bar>

        <v-navigation-drawer
                style="min-height: 100%;position: fixed;max-height:55px;justify-content:center;background: rgb(0,83,108);background: linear-gradient(0deg, rgba(0,83,108,0.999019676229867) 15%, rgba(0,186,196,1) 100%);"
                absolute floating dark
                app :width="210"
                v-model="drawer">

            <v-list class="pt-16" dense>
                <v-list-item class="pa-1" two-line>
                    <v-list-item-avatar>
                        <v-icon large color="white">
                            mdi-account-circle
                        </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title style="color: #FFFFFF">Έχετε συνδεθεί ως:</v-list-item-title>
                        <v-list-item-subtitle><b style="color: #FFFFFF">{{Object.keys($store.getters.homePageInformation).length
                            > 0 ? $store.getters.homePageInformation.bookSupplier.username : ''}}</b>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list dense>
                <div v-for="(navigationItem, j) in $store.getters.navigationItems" :key="j">
                    <v-list-item
                            :disabled="navigationItem.disabled"
                            @click="linkToOtherPage(navigationItem)"
                            :class="navigationItem.link === navigationPath ? 'default-class elevation-10 pa-1' : 'pa-1'"
                            ripple>
                        <v-layout row>
                            <v-list-item-action>
                                <v-icon :color="navigationItem.link === navigationPath ?'secondary':'white'"
                                        class="ml-3">{{navigationItem.icon}}
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content class="text-truncate pa-0 ma-0">
                                <v-list-item-title v-html="replaceWithBr(navigationItem.label)"
                                                   :style="navigationItem.link === navigationPath ?'font-size: 14px;color:#3FFFFA;text-align: left':'font-size: 14px;color:#ffffff;text-align: left'">

                                </v-list-item-title>
                            </v-list-item-content>
                        </v-layout>
                    </v-list-item>
                </div>
            </v-list>
        </v-navigation-drawer>


        <v-main class="mt-5">
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-main>
        <Footer/>
    </v-app>
</template>

<script>
	import LoginModal from "@/components/LoginModal.vue";
	import LoadingComponent from "@/components/LoadingComponent.vue";
	import Footer from "@/components/Footer.vue";
	import ErrorPopup from "@/components/ErrorPopup.vue";
	import requests from "./requests";
	import utils from "@/utilities";
	// require("../src/assets/EUDOXUS_NEW_LOGO.png");

	export default {
		name: 'App',
		components: {ErrorPopup, LoginModal, LoadingComponent, Footer},
		data: () => ({
			drawer: true,
			asyncRequests: 0,
			navigationPath: '/',
			sidebarMenu: true,

		}),
		computed: {
			buttonText() {
				return !this.$vuetify.theme.dark ? 'Go Dark' : 'Go Light'
			}
		},
		methods: {

			replaceWithBr(input) {
				return input.replace(/\n/g, "<br />")
			},


			redirectLoginOrMainPage() {

				var token = utils.getLocalStorage('sup_token');
				if (token != null) {

					this.$store.commit('setLoadingModal', true);
					requests.get('rest/user/home', this.homePageInformationCallBack);
					requests.get('rest/user/academic-years', this.yearsCallBack);
				} else {
					this.$store.commit('setLoginModal', true);
				}

			},


			homePageInformationCallBack(response) {
				this.$store.commit('setHomePageInformation', response);
				utils.createNavigationItem();
				this.asyncRequests++;

			},

			yearsCallBack(response) {
				this.$store.commit('setYearsInfo', response);
				this.asyncRequests++;
			},


			logout() {

				var token = utils.getLocalStorage('sup_token');
				if (token != null) {
					this.$store.commit('setLoadingModal', true);
					requests.logout(token, this.logoutCallBack);
				} else {
					utils.removeTokenFromBrowser();
					this.$store.commit('setLoginModal', true);
				}
			},

			logoutCallBack(response) {

				this.$store.commit('setLoadingModal', false);
				utils.removeTokenFromBrowser();
				if (this.navigationPath !== '/')
					this.$router.push({path: '/'})

				this.$store.dispatch('resetState');
			},


			linkToOtherPage(item) {
				if (this.navigationPath != item.link) {
					if (item.link === '/search') {
						window.open("https://service.eudoxus.gr/search/", '_blank');
					} else {
						this.navigationPath = item.link;
						this.$router.push({path: item.link});
					}
				}
			},

		},

		created() {
			// utils.createNavigationItem();
			this.redirectLoginOrMainPage();
			if (window.performance) {
				// console.info("window.performance works fine on this browser");
			}
			if (performance.navigation.type === 1) {
				this.$router.push({path: '/'})
			} else {
				// console.info( "This page is not reloaded");
			}

		},
		watch: {
			'$route'(to, from) {
				if (to.path !== this.navigationPath) {
					this.navigationPath = to.path;
				}
			},
			'asyncRequests': function (val) {
				if (val === 2) {
					this.$store.commit('setLoadingModal', false);
					this.$store.commit('setLoginModal', false);
					this.asyncRequests = 0;
				}
			},
		},

	}
</script>


<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .v-btn {
        text-transform: none !important;
        font-weight: bold !important;
    }

    nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    nav a.router-link-exact-active {
        color: #42b983;
    }
</style>
